// extracted by mini-css-extract-plugin
export var container = "_kz-0";
export var dotAnimation = "_kz-2";
export var dotsLoading = "_kz-1";